import { useTranslation } from 'react-i18next';
import { Metric } from './Metric';

interface PaymentPlanMetricProps {
  /** Which of PaymentSummaryCard's two responsive layouts this instance renders. Both mount
   *  simultaneously (CSS visibility, not conditional) — this only changes the markup shape. */
  layout: 'narrow' | 'wide';
  /** Positional padding for the wide 3-column grid, or the narrow full-width strip below the row
   *  — owned by the parent grid, not this metric. */
  className?: string;
}

// Hardcoded to the design's "none" state until a follow-on story wires real data into this slot.
export function PaymentPlanMetric({ layout, className }: PaymentPlanMetricProps) {
  const { t } = useTranslation('members');

  if (layout === 'narrow') {
    return (
      <div className={className}>
        <div className="text-sm text-muted-foreground">{t('payments.paymentSummary.paymentPlan.label')}</div>
        <div className="text-2xl font-bold leading-tight text-muted-foreground">{'—'}</div>
        <div className="mt-1.5 text-xs text-muted-foreground">{t('payments.paymentSummary.paymentPlan.none')}</div>
      </div>
    );
  }

  return (
    <Metric
      label={t('payments.paymentSummary.paymentPlan.label')}
      className={className}
      data-slot="metric-payment-plan"
      data-state="none"
    >
      <div className="text-2xl font-semibold leading-none text-muted-foreground">{'—'}</div>
      <div className="mt-2 text-xs text-muted-foreground">{t('payments.paymentSummary.paymentPlan.none')}</div>
    </Metric>
  );
}
